import { global } from '../utils/globals';
import assert from '../utils/assert';
import { getBinaryImageMetadata } from '../category-api/binary-image-api';
export default function parseToNodeImage(arrayBuffer, options) {
  var _ref = getBinaryImageMetadata(arrayBuffer) || {},
      mimeType = _ref.mimeType;

  var _parseImageNode = global._parseImageNode;
  assert(_parseImageNode);
  return _parseImageNode(arrayBuffer, mimeType, options);
}
//# sourceMappingURL=parse-to-node-image.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/images/dist/esm/lib/parsers/parse-to-node-image.js